"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckContentShareConnectivityFeedback = void 0;
var CheckContentShareConnectivityFeedback;
(function (CheckContentShareConnectivityFeedback) {
    CheckContentShareConnectivityFeedback[CheckContentShareConnectivityFeedback["Succeeded"] = 0] = "Succeeded";
    CheckContentShareConnectivityFeedback[CheckContentShareConnectivityFeedback["Failed"] = 1] = "Failed";
    CheckContentShareConnectivityFeedback[CheckContentShareConnectivityFeedback["PermissionDenied"] = 2] = "PermissionDenied";
    CheckContentShareConnectivityFeedback[CheckContentShareConnectivityFeedback["TimedOut"] = 3] = "TimedOut";
    CheckContentShareConnectivityFeedback[CheckContentShareConnectivityFeedback["ConnectionFailed"] = 4] = "ConnectionFailed";
})(CheckContentShareConnectivityFeedback = exports.CheckContentShareConnectivityFeedback || (exports.CheckContentShareConnectivityFeedback = {}));
exports.default = CheckContentShareConnectivityFeedback;
